import { Schema } from "rsuite";

const { StringType, ArrayType, NumberType, DateType } = Schema.Types;

export const AppointmentFormSchema = Schema.Model({
  TaskStartTime: DateType().isRequired("Task Start Time is required"),
  MaxHours: NumberType().max(16).isRequired("MaxHour(s) is required"),
  PatientSKey: StringType().isRequired("Patient is required"),
  RequestedCaregiverSKeys: ArrayType().isRequired("Caregiver(s) is required"),
  Certificates: ArrayType("Please select valid files"),
  AppointmentStartDate: DateType().isRequired(
    "Appointment Start Date is required"
  ),
  AppointmentEndDate: DateType().isRequired("Appointment End Date is required"),
});
